/** Map integration type to ApplicationIcon logo (used by both list rows and side panels). */
export function getApplicationLogo(application: string): string {
  const type = application?.toUpperCase?.() ?? "";
  if (type === "GCPVERTEXAI" || type === "GOOGLE_VERTEX_DISCOVERY")
    return "GCP";
  if (type === "GOOGLEPLATFORM") return "GCP";
  if (type === "AGENTFORCE") return "Salesforce";
  if (type === "COPILOTSTUDIO") return "MSOffice365";
  if (type === "AZUREPLATFORM" || type === "AZUREFOUNDRY") return "Azure";
  if (type === "NOWASSIST" || type === "SERVICENOW" || type === "SERVICENOWAI")
    return "ServiceNow";
  if (type === "AWSPLATFORM" || type === "AWSPOSTURE") return "AWS";
  if (type === "ENTRAID" || type === "ENTRAIDIS") return "EntraID";
  if (type.startsWith("OKTA")) return "Okta";
  return application;
}

/** Map integration type to display name beside the icon. */
export function getApplicationDisplayName(application: string): string {
  const type = application?.toUpperCase?.() ?? "";
  if (type === "GCPVERTEXAI" || type === "GOOGLE_VERTEX_DISCOVERY")
    return "GCP Vertex AI";
  if (type === "GOOGLEPLATFORM") return "Google Platform";
  if (type === "AGENTFORCE") return "Agent Force";
  if (type === "COPILOTSTUDIO") return "Copilot Studio";
  if (type === "AZUREPLATFORM") return "Azure Platform";
  if (type === "AZUREFOUNDRY") return "Azure AI Foundry";
  if (type === "NOWASSIST") return "Now Assist";
  if (type === "SERVICENOWAI") return "ServiceNow AI";
  if (type === "ENTRAID" || type === "ENTRAIDIS") return "Entra ID";
  if (type.startsWith("OKTA")) return "Okta";
  return application;
}

export function isManagementFlowType(application: string): boolean {
  const type = application?.toUpperCase?.() ?? "";
  return type === "ENTRAID" || type === "ENTRAIDIS" || type.startsWith("OKTA");
}
